import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderRoutingModule } from './order-routing.module';
import { ComponentModule } from '../component/component.module';
import { OrderAddComponent } from './order-add/order-add.component';
import { OrderListComponent } from './order-list/order-list.component';
import { ExpenseReportFormComponent } from './expense-report-form/expense-report-form.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AgGridModule} from 'ag-grid-angular'
import { NgxDropzoneModule } from 'ngx-dropzone'
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OrderChangedUnitComponent } from './order-changed-unit/order-changed-unit.component'
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { DetailPanelComponent } from '../cell-renderer/detail-panel/detail-panel.component';
import { BillServiceComponent } from './bill-service/bill-service.component';
import { InvoiceViewComponent } from './invoice-view/invoice-view.component';
import { ExpenseSummaryComponent } from './expense-summary/expense-summary.component';
import { ExpenseValidationComponent } from './expense-validation/expense-validation.component';
import { ApproveRejectModalComponent } from './expense-validation/approve-reject-modal/approve-reject-modal.component';
import { DepositsListComponent } from './deposits-list/deposits-list.component';
import { DepositFormComponent } from './deposit-form/deposit-form.component';
import { UnifyViaticosModalComponent } from './unify-viaticos-modal/unify-viaticos-modal.component';
import { UnifiedViaticosModalComponent } from './unified-viaticos-modal/unified-viaticos-modal.component';
import { SeparationResultModalComponent } from './separation-result-modal/separation-result-modal.component';
import { UnifiedHistoryTabComponent } from './unified-history-tab/unified-history-tab.component';
import { UnifiedExpensesTableComponent } from './unified-expenses-table/unified-expenses-table.component';
import { ServiceExpenseGroupModalComponent } from './service-expense-group-modal/service-expense-group-modal.component';


@NgModule({
  declarations: [
    OrderAddComponent,
    OrderListComponent,
    OrderDetailComponent,
    OrderChangedUnitComponent,
    DetailPanelComponent,
    ExpenseReportFormComponent,
    BillServiceComponent,
    InvoiceViewComponent,
    ExpenseSummaryComponent,
    ExpenseValidationComponent,
    ApproveRejectModalComponent,
    DepositsListComponent,
    DepositFormComponent,
    UnifyViaticosModalComponent,
    UnifiedViaticosModalComponent,
    SeparationResultModalComponent,
    UnifiedHistoryTabComponent,
    UnifiedExpensesTableComponent,
    ServiceExpenseGroupModalComponent
  ],
  imports: [
    CommonModule,
    OrderRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AgGridModule,
    NgxDropzoneModule,
    AutocompleteLibModule,
    ComponentModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrderModule { }
